import angular from 'angular';
import multiselectComponent from './multiselect.component';

let multiselectModule = angular.module('multiselect', [])
  .directive('multiselect', multiselectComponent);
export default multiselectModule;



// WEBPACK FOOTER //
// ./app/common/multiselect/multiselect.js